import React from 'react';
import { SectionContainer } from '../../ticketForm/components/SectionContainer';
import { SectionBody } from '../../ticketForm/components/SectionBody';
import { SectionLine } from '../../ticketForm/components/SectionLine';
import { FormikPremiumInput } from '../../ui/inputs/customInput';
import SectionTitle from '../../ticketForm/components/SectionTitle';
import SpecialLabelText from '../../ticketForm/components/SpecialLabelText';

export const QuotePickupSection = ({ quoteFormBodyData }) => {
  const { showErrors, isEdit, isReadOnly, ticketDetail } = quoteFormBodyData;
  return (
    <SectionContainer>
      <SectionTitle>Pickup</SectionTitle>
      <SectionBody>
        <SectionLine>
          <SpecialLabelText>
            {ticketDetail.order_data.pickup.city} {ticketDetail.order_data.pickup.country} -{' '}
            {ticketDetail.order_data.pickup.zipcode}
          </SpecialLabelText>
        </SectionLine>
        <SectionLine>
          <FormikPremiumInput
            label="Date"
            showErrors={showErrors}
            name="order_data.pickup.date"
            type="date"
            isRequired={true}
            isDisabled={isEdit || isReadOnly}
          />
          <FormikPremiumInput
            label="Start time"
            isRequired={true}
            showErrors={showErrors}
            name="order_data.pickup.time_from"
            type="time"
            isDisabled={isEdit || isReadOnly}
          />
          <FormikPremiumInput
            label="End time"
            showErrors={showErrors}
            name="order_data.pickup.time_to"
            type="time"
            isRequired={true}
            isDisabled={isEdit || isReadOnly}
          />
        </SectionLine>
      </SectionBody>
    </SectionContainer>
  );
};
